
import Vue from "vue";
import Component from "vue-class-component";

@Component({
  name: "PedidoEnviadoDialog",
})
export default class PedidoEnviadoDialog extends Vue {
  private dlgVisible = false;
  private confirmSvg = require("@/assets/confirm.svg");

  show() {
    this.dlgVisible = true;
  }

  onVoltarInicioClick() {
    this.$router.push("/home");
  }

  onVerHistoricoClick() {
    this.$router.push("/pedidos");
  }
}
